import React from "react";

const CookiesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8 md:p-12">
        {/* Header */}
        <div className="mb-10 pb-8 border-b-2 border-gray-200">
          <h1 className="text-h2 text-dark4 mb-4">Cookie Policy</h1>
          <p className="text-bodyMR text-dark5">
            Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>

        {/* Content */}
        <div className="space-y-8">
          {/* Introduction */}
          <section className="space-y-4">
            <p className="text-bodyLR text-dark5 leading-relaxed">
              This Cookie Policy explains how Testament.digital uses cookies and similar technologies to recognize 
              you when you visit our website. It explains what these technologies are and why we use them, as well 
              as your rights to control our use of them.
            </p>
          </section>

          {/* Section 1 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">1. What Are Cookies</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              Cookies are small data files that are placed on your computer or mobile device when you visit a website. 
              Cookies are widely used by website owners to make their websites work, or to work more efficiently, 
              as well as to provide reporting information.
            </p>
          </section>

          {/* Section 2 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">2. Types of Cookies We Use</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              We use both session and persistent cookies on our website. The types of cookies we use include:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li className="text-bodyMR text-dark5">
                <strong>Essential Cookies:</strong> These cookies are necessary for the website to function and cannot 
                be switched off in our systems.
              </li>
              <li className="text-bodyMR text-dark5">
                <strong>Performance Cookies:</strong> These cookies allow us to count visits and traffic sources so we 
                can measure and improve the performance of our site.
              </li>
              <li className="text-bodyMR text-dark5">
                <strong>Functionality Cookies:</strong> These cookies enable the website to provide enhanced functionality 
                and personalization.
              </li>
              <li className="text-bodyMR text-dark5">
                <strong>Targeting Cookies:</strong> These cookies may be set through our site by our advertising partners 
                to build a profile of your interests.
              </li>
            </ul>
          </section>

          {/* Section 3 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">3. How We Use Cookies</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              We use cookies for several purposes, including:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li className="text-bodyMR text-dark5">To authenticate users and prevent fraudulent use of user accounts</li>
              <li className="text-bodyMR text-dark5">To remember your preferences and settings</li>
              <li className="text-bodyMR text-dark5">To analyze how you use our website and improve our services</li>
              <li className="text-bodyMR text-dark5">To deliver personalized content and advertisements</li>
            </ul>
          </section>

          {/* Section 4 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">4. Third-Party Cookies</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              In addition to our own cookies, we may also use various third-party cookies to report usage statistics 
              of the website, deliver advertisements, and so on. These third-party cookies are governed by the respective 
              privacy policies of those third parties.
            </p>
          </section>

          {/* Section 5 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">5. Your Cookie Choices</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              You have the right to decide whether to accept or reject cookies. You can exercise your cookie rights by 
              setting your preferences in your browser settings. However, please note that if you choose to reject cookies, 
              you may not be able to use all the features of our website.
            </p>
          </section>

          {/* Section 6 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">6. Changes to This Cookie Policy</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              We may update this Cookie Policy from time to time to reflect changes in the cookies we use or for other 
              operational, legal, or regulatory reasons. Please revisit this Cookie Policy regularly to stay informed 
              about our use of cookies.
            </p>
          </section>

          {/* Contact Section */}
          <section className="mt-12 pt-8 border-t-2 border-gray-200">
            <h2 className="text-h5 text-dark4 font-semibold mb-4">Contact Us</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              If you have any questions about our use of cookies or this Cookie Policy, please contact us at{" "}
              <a href="mailto:cookies@testament.digital" className="text-primary hover:underline">
                cookies@testament.digital
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;
